import rallax from '../vendor/rallax';
import simpleParallax from 'simple-parallax-js';

(function($) {
    /**
     * Add aria labels
     */
    $('#site-navigation').attr('aria-label', 'Main');
    $('.page-search nav.pagination').attr('aria-label', 'Search Results Pagination');

    /**
     * Set an active class on form field focus
     */
    $(document).on('focus','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').addClass("active");
    }).on('blur','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').removeClass("active");
    });

    /**
     * Add padding to the body of the page if the cookie bar is active
     * This prevents the cookie bar from overlapping the footer
     */
    var cookiebarPadding = function() {
        var $cookiebar = $('#cookie-law-info-bar');

        if ($cookiebar.length) {
            if ($cookiebar.css('display') == 'block') {
                $cookiebar_height = $cookiebar.outerHeight();
                $('body').css('padding-bottom', $cookiebar_height);
                return;
            }
        }

        $('body').css('padding-bottom', 0);
    }

    $(window).on('resize', cookiebarPadding);
    cookiebarPadding();

    var observer = new MutationObserver(function(mutations) {
        cookiebarPadding();
    });

    var target = document.querySelector('#cookie-law-info-bar');
    if (target) {
        observer.observe(target, {
            attributes: true
        });
    }

    /**
     * Add key listeners to the cookiebar dismiss link
     */
    var triggerCookiebarDismiss = function( e ) {
        
        if(e.which == 13) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }

        if(e.which == 32) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }
    }

    $(document).on('keyup', '#cookie_action_close_header', triggerCookiebarDismiss );

    if ( $('.p-hero').length > 0 ) {
        rallax( document.querySelector('.p-hero'), { speed: 0.5 } );
    }

    if ( $('.p-content').length > 0 ) {
        rallax( document.querySelector('.p-content'), { speed: 0.5 } );
    }

    if ( $('.default-parallax').length > 0 ) {
        rallax( document.querySelector('.default-parallax'), { speed: 0.5 } );
    }
    
    var images = document.querySelectorAll('.hero-service__image, .single-service__outcome__image img, .single-service__included-services__image img');
    if (images) {
        new simpleParallax(images, {
            delay: 0,
            orientation: 'up',
            scale: 1.15,
            overflow: true,
        });
    }

    $(document).on("gform_confirmation_loaded", function (e, form_id) {
        $('#gf_' + form_id).closest('.pum-container').addClass('form-submitted');
        $('#gf_' + form_id).closest('.footer-form').addClass('form-submitted');
    });
})(jQuery);